import ExpandMoreIcon from "@mui/icons-material/ExpandMore";
import {
  Accordion,
  AccordionDetails,
  AccordionSummary,
  Button,
  Checkbox,
  Grid,
  Typography,
} from "@mui/material";
import Box from "@mui/material/Box";
import * as React from "react";
import { useRecordContext } from "react-admin";
import { Controller, useForm } from "react-hook-form";
import CustomProductSelect from "../../unit/forms/CustomProductSelect";
import CustomProductTextField from "../../unit/forms/CustomProductTextField";
import SectionStyled from "./SectionStyled";
import SectionTitle from "./SectionTitle";
import CustomProductActionBottom from "../CustomProductActionBottom";
import { watch } from "fs";
import customSortArrays from "../../unit/sortArrays";

export default function Preunderwriting({
  onSave,
  defaultValues,
  ...props
}: any) {
  const record = useRecordContext();
  const sectionName = "preUnderwriting";
  const sectionTitle =
    "Pre-Underwriting - Set review items before initiating review";
  const sectionSubtitle = "";

  const data = record?.data?.basic?.preUnderwriting;
  const skipReview = data?.skipReview;
  const preunderwringData = data?.preunderwringData || [];
  const [showDetail, setShowDetail] = React.useState(false);
  const [isActualDirty, setIsActualDirty] = React.useState(false);
  const [initialValuesSet, setInitialValuesSet] = React.useState({});

  // const data = React.useMemo(
  //   () => record?.data?.basic?.preUnderwriting,
  //   [record?.data?.basic?.preUnderwriting] // 只在真实数据变化时更新
  // );
  // const skipReview = data?.skipReview;
  // const preunderwringData = React.useMemo(
  //   () => data?.preUnderwriting || [],
  //   [data]
  // );

  const hasSetBaseline = React.useRef(false);
  // const [actualDirty, setActualDirty] = React.useState(false);
  const {
    control,
    handleSubmit,
    formState: { errors, isDirty, dirtyFields },
    reset,
    getValues,
    setValue,
    watch,
  } = useForm({
    mode: "onChange",
  });

  const allValues = watch();

  console.log("Check allValues:", allValues);
  // React.useEffect(() => {
  //   const hasChanges =
  //     JSON.stringify(customSortArrays(initialValuesSet)) !==
  //     JSON.stringify(customSortArrays(allValues));
  //   setIsActualDirty(hasChanges);
  //   if (props?.onDirtyChange) {
  //     props?.onDirtyChange(props?.curMenu, hasChanges);
  //   }
  // }, [allValues]);

  // 现有的初始化代码保持不变
  React.useEffect(() => {
    const rafId = requestAnimationFrame(() => {
      if (!hasSetBaseline.current) {
        const currentValues = getValues();
        console.log("Check 初始化数据:", currentValues);
        setInitialValuesSet(currentValues);
        reset(currentValues);
        hasSetBaseline.current = true;
      }
    });
    return () => cancelAnimationFrame(rafId);
  }, [getValues, reset]);

  React.useEffect(() => {
    // 只在初始化后执行
    if (!hasSetBaseline.current) return;

    // 检查是否有真正修改的字段
    const hasRealChanges = Object.keys(dirtyFields).length > 0;

    // 更新实际脏状态
    setIsActualDirty(hasRealChanges);

    // 通知父组件
    if (props?.onDirtyChange) {
      props?.onDirtyChange(props?.curMenu, hasRealChanges);
    }
  }, [dirtyFields, props?.curMenu]);

  React.useEffect(() => {
    // console.log("Check when isDirty changed=====>:", isDirty);
    if (props?.onDirtyChange) {
      props?.onDirtyChange(props?.curMenu, isDirty);
    }
  }, [isDirty, reset]);

  const handleSaveClick = () => {
    const formData = getValues();
    formData.saveAction = sectionName;
    console.log("Check Form data:", formData);
    if (onSave) {
      onSave(formData, props?.curMenu);
      reset(formData); //保存后重置表单状态，isDirty 变为 false
    }
  };
  const PreRequirementGrid = ({ item }) => {
    return (
      <Grid container sx={{ py: 1, borderBottom: "1px solid #eee" }}>
        <Grid item xs={1} sx={{ display: "flex", alignItems: "center" }}>
          <Controller
            name={`reviewitemIds_key_${item.key}`}
            control={control}
            defaultValue={item.isSelect == true ? true : false}
            render={({ field }) => (
              <Checkbox
                {...field}
                checked={field.value}
                onChange={(e) => {
                  field.onChange(e.target.checked);
                  if (e.target.checked) {
                    setValue(`reviewitemIds_required_${item.key}`, "Required");
                  } else {
                    setValue(`reviewitemIds_required_${item.key}`, "N/A");
                  }
                }}
              />
            )}
          />
        </Grid>
        <Grid item xs={4} sx={{ display: "flex", alignItems: "center" }}>
          <Typography variant="body1">{item.title}</Typography>
        </Grid>
        <Grid item xs={3}></Grid>
        <Grid item xs={3}>
          {item.key === "specific_documents" && (
            <Controller
              name={`reviewitemIds_itemvalue_${item.key}`}
              control={control}
              defaultValue={item.itemValue || ""}
              render={({ field }) => (
                <CustomProductTextField
                  {...field}
                  variant="outlined"
                  fullWidth
                  placeholder="Enter Document Name"
                  onChange={(e) => {
                    field.onChange(e.target.value);
                    setValue(`reviewitemIds_${item.key}`, e.target.value);
                  }}
                />
              )}
            />
          )}
          {item.key === "specific_review" && (
            <Controller
              name={`reviewitemIds_itemvalue_${item.key}`}
              control={control}
              defaultValue={item.itemValue || ""}
              render={({ field }) => (
                <CustomProductTextField
                  {...field}
                  variant="outlined"
                  fullWidth
                  placeholder="Enter Review Topic"
                  onChange={(e) => {
                    field.onChange(e.target.value);
                    setValue(`reviewitemIds_${item.key}`, e.target.value);
                  }}
                />
              )}
            />
          )}
        </Grid>
        <Grid item xs={1} sx={{ display: "flex", alignItems: "center" }}>
          <Controller
            name={`reviewitemIds_required_${item.key}`}
            control={control}
            defaultValue={item.sRequired || "N/A"}
            render={({ field }) => (
              <CustomProductSelect
                {...field}
                variant="outlined"
                small
                fullWidth
                optionlist={[
                  { value: "N/A", label: "N/A" },
                  { value: "", label: "Optional" },
                  { value: "Required", label: "Required" },
                ]}
                onChange={(e) => {
                  field.onChange(e.target.value);
                  setValue(
                    `reviewitemIds_${item.key}`,
                    e.target.value !== "N/A"
                  );
                }}
              />
            )}
          />
        </Grid>
      </Grid>
    );
  };

  return (
    <SectionStyled id={"section_" + sectionName}>
      <SectionTitle subtitle={sectionSubtitle} title={sectionTitle} />

      <Box
        sx={{
          padding: "10px",
          height: "calc(100vh - 255px)",
          overflowY: "auto",
          // background: "yellow",
        }}
      >
        {skipReview != "NO" && (
          <Typography
            sx={{
              backgroundColor: "#fcf8e3",
              color: "#8a6d3b",
              padding: "10px",
            }}
          >
            To edit this section, change <b>"Review/Process/Skip Reviews"</b>
            setting to "No".
          </Typography>
        )}
        {skipReview == "NO" && (
          <>
            {Object.entries(preunderwringData).map(([category, items]) => (
              <Accordion key={category} defaultExpanded>
                <AccordionSummary
                  expandIcon={<ExpandMoreIcon />}
                  aria-controls={`${category}-content`}
                  id={`${category}-header`}
                  sx={{ backgroundColor: "#f5f5f5" }}
                >
                  <Typography variant="subtitle1">{items?.title}</Typography>
                </AccordionSummary>
                <AccordionDetails>
                  {items?.list?.map((item) => (
                    <PreRequirementGrid key={item.key} item={item} />
                  ))}
                </AccordionDetails>
              </Accordion>
            ))}
          </>
        )}
      </Box>
      <CustomProductActionBottom>
        <Button
          variant="contained"
          color="primary"
          onClick={handleSaveClick}
          disabled={!isDirty}
          sx={{ width: "120px", mt: 1 }}
        >
          Save
        </Button>
      </CustomProductActionBottom>
    </SectionStyled>
  );
}
